require(151);
module.exports = require(58).Object.entries;
